{
  "embed_url_form": {
    "validation": {
      "url_required": "L'URL est requise",
      "name_required": "Le nom est requis"
    },
    "modal": {
      "new_embed_url": "Nouvelle URL intégrée"
    },
    "fields": {
      "title": "Titre",
      "url": "URL"
    }
  },
  "report_tabs": {
    "iframe_title": "Rapport {{name}}"
  }
}
